import { render, staticRenderFns } from "./Four.vue?vue&type=template&id=0122916a&scoped=true"
import script from "./Four.vue?vue&type=script&lang=js"
export * from "./Four.vue?vue&type=script&lang=js"
import style0 from "./Four.vue?vue&type=style&index=0&id=0122916a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0122916a",
  null
  
)

export default component.exports